<template>
  <div class="quick-chat">
    <!-- title & back button -->
    <div class="quick-chat__header d-flex align-items-center px-2">
      <b-icon-chevron-left scale="1" @click="$emit('close')" />
      <h4 class="mb-0">Quick Chat</h4>
    </div>

    <!-- chat content -->
    <div class="quick-chat__body px-2 py-2">
      <div
          v-for="(message, mIndex) in conversationMessages"
        :key="message.message_id"
        :class="mIndex === conversationMessages.length - 1
          ? 'lastMessage'
          : `message${mIndex} mb-2`
        "
      >
        <div v-if="message.direction == 'outbound'" class="quick-chat__outbound">
          <div class="quick-chat__outbound-img">
            <img
              src="/images/rcl-logo-badge-50.png"
              alt="user"
              class="rounded-circle"
            />
          </div>
          <div class="quick-chat__outbound-content ps-2">
            <div class="d-flex align-items-end mb-2">
              <h5 class="text-muted fs-2 font-weight-medium mb-0" style="line-height: 1;">{{ message.operator }}</h5>
              <div class="text-end fs-1 font-weight-medium align-bottom ml-2" style="line-height: 1;">
                {{ formatTimestamp(message.created_at) }}
              </div>
            </div>
            <div class="quick-chat__outbound-box text-dark font-weight-medium fs-2 bg-light-primary px-2 py-2" style="max-width: 90%;">
              <div v-if="message.body_transl && message.body_transl !== message.body && message.language != 'en'" class="pb-3">
                {{ message.body_transl }}
              </div>
              <div>
                <span style="white-space: pre-line">{{ message.message_body }}</span>
              </div>
            </div>
          </div>
          <div />
        </div>
        <div v-else class="quick-chat__inbound">
          <div />
          <div />
          <div class="quick-chat__inbound-content ps-2 d-flex flex-column align-items-end">
            <div class="text-end fs-1 font-weight-medium">
                {{ formatTimestamp(message.created_at) }}
            </div>
            <div class="quick-chat__inbound-box text-dark font-weight-medium fs-2 bg-light-inverse px-2 py-2">
              <span v-if="message.language && message.language != 'en' && message.body_transl">
                {{ message.body }}
              </span>
              <span v-else>{{ message.message_body }}</span>
            </div>
          </div>  
        </div>
      </div>
    </div>

    <!-- inputbox to send meessage -->
    <div class="quick-chat__footer px-2">
      <div>
        <MessageBox
          ref="messageBox"
          v-model="message"
          @send-message="sendMessage"
        />
      </div>
      <div>
        <b-button no-caret @click="sendMessage()" class="bg-transparent mt-1 p-0" variant="link">
          <b-spinner v-if="httpPending === true" small></b-spinner>
          <p v-else class="h2 m-0"><b-icon-arrow-up-circle-fill variant="info" /></p>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import moment from "moment-timezone";
import { EventBus } from "../events/eventBus";
import ImageItem from "./ImageItem";
import MessageBox from "./conversations/MessageBox.vue";

export default {
  name: "QuickChat",
  components: { ImageItem, MessageBox },
  props: { magicToken: Object },
  data() {
    return {
      message: null,
      loading: false,
      httpPending: false,
      conversationMessages: [],
    };
  },
  created() {
    EventBus.$on("chat.receive-message", async (conversationId) => {
      if (this.magicToken && conversationId === this.magicToken.token_data.conversation_id) {
        // console.log("caller received message from operator");
        await this.fetchMessages();
        this.$nextTick(() => {
          this.scrollToLastMessage();
        })
      }
    });
  },
  methods: {
    formatTimestamp(t) {
      try {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const formattedTime = moment.utc(t, "x").tz(tz).format("LT");
        return formattedTime;
      } catch (e) {
        return t;
      }
    },
    async sendMessage() {
      if (!this.magicToken)
        return;

      this.httpPending = true;
      try {
        const conversationId = this.magicToken.token_data.conversation_id;
        const agencyId = this.magicToken.token_data.agency_id;
        const recipientNumber = this.magicToken.token_data.recipient;

        const payload = {
          direction: "inbound",
          body: this.message.trim(),
          conversation_id: conversationId,
          recipient_number: recipientNumber,
        };

        await this.$ConveyApi.messagesApi.createMessage({ payload })
          .then((resp) => {
            const message = resp.data.data;
            this.conversationMessages.push(message);
            this.httpPending = false;
            this.message = null;
            const audio = new Audio("/assets/audio/juntos-607.ogg");
            audio.play();
            EventBus.$emit("chat.send-message", { conversationId, agencyId, message, source: null});
          })
          .catch((err) => {
            const audio = new Audio("/assets/audio/glitch-in-the-matrix-600.ogg");
            audio.play();

            this.$toastr("error", "Message send error. Please try again");
            this.httpPending = false;
            console.log(err);
          });
      } catch (err) {
        const audio = new Audio("/assets/audio/glitch-in-the-matrix-600.ogg");
        audio.play();

        this.$toastr("error", "Message send error. Please try again");
        this.httpPending = false;
        console.log(err);
      }
      this.$nextTick(() => {
        this.scrollToLastMessage();
      })
    },
    async fetchMessages() {
      this.loading = true;
      try {
        const conversationId = this.magicToken.token_data.conversation_id;
        const resp = await this.$ConveyApi.conversationsApi.getMessagesForConversation({ conversationId });
        this.conversationMessages = resp.data.data;
        this.loading = false;
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    scrollToLastMessage() {
      const container = document.querySelector(".quick-chat");
      const scrollHeight = container.scrollHeight;
      container.scrollTop = scrollHeight;
    },
  },
  watch: {
    magicToken: {
      async handler(token) {
        if (token) {
          await this.fetchMessages();
          this.$nextTick(() => {
            this.scrollToLastMessage();
          })
        }
      },
      immediate: true,
      deep: true,
    }
  }
}
</script>

<style lang="scss">
.quick-chat {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  background-color: white;

  &__header {
    position: fixed;
    top: 0;
    width: 100%;
    height: 60px;
    display: grid;
    grid-template-columns: max-content 1fr;
    grid-column-gap: 1rem;
    box-shadow: 1px 0px 7px rgb(0 0 0 / 5%);
    border-bottom: 1px solid #e9ecef;
    background-color: white;
    z-index: 999;
  }

  &__body {
    width: 100%;
    height: auto;
    margin-top: 60px;
    margin-bottom: 60px;
    background-color: white;

    > div {
      width: 100%;
      .quick-chat {
        &__outbound {
          display: grid;
          grid-template-columns: 45px 9fr 1fr;
          grid-column-gap: 0.5rem;
          &-box {
            width: fit-content;
            max-width: 100%;
            text-align: left;
            border-top-right-radius: 20px;
            border-bottom-left-radius: 20px;
            border-top-left-radius: 5px;
            border-bottom-right-radius: 5px;
            > span {
              white-space: pre-line;
            }
          }
        }
        &__inbound {
          display: grid;
          grid-template-columns: 45px 1fr 9fr;
          grid-column-gap: 0.5rem;
          &-box {
            width: fit-content;
            max-width: 100%;
            text-align: left;
            border-top-right-radius: 5px;
            border-bottom-left-radius: 5px;
            border-top-left-radius: 20px;
            border-bottom-right-radius: 20px;
            > span {
              white-space: pre-line;
            }
          }
        }
      }
    }
  }

  &__footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 60px;
    display: grid;
    grid-template-columns: 1fr max-content;
    grid-column-gap: 0.5rem;
    align-items: center;
    box-shadow: 1px 0px 7px rgb(0 0 0 / 5%);
    border-top: 1px solid #e9ecef;
    background-color: white;
    z-index: 999;
  }
}
</style>